import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {EvsStampService} from '../../../../../common/services/EvsStamp.service';
import {ActivatedRoute, Params, Router} from '@angular/router';

declare var $;
var that;

@Component({
  selector: 'app-guarantee-setting',
  templateUrl: './guarantee-setting.component.html',
  styleUrls: ['./guarantee-setting.component.css'],
  providers: [EvsStampService],
})
export class GuaranteeSettingComponent implements OnInit {
  @Input() type: any;
  @Output() onBack = new EventEmitter<any>();
  numberField: any = 0;
  numberObj: any = {};
  listField: any = [];
  listType: any = [];
  listFieldData: any = [];
  listTypeText: any = ['input', 'textarea', 'select', 'radio', 'checkbox'];
  haveNew: boolean = false;

  constructor(private stampService: EvsStampService, private router: Router, private translate: TranslateService) {
    that = this;
  }


  ngOnInit() {
    this.getListField();
  }

  activeTab = 1;

  changeTab(event) {
    if (event !== this.activeTab) {
      this.activeTab = event;
      if (event === 1) {
        this.getListField();
      }
      if (event === 2) {

      }

    }
  }

  getListField() {
    this.stampService.getListField().subscribe((res) => {
      if (!res.error) {
        let listTypeTextObj = res.data;
        let listTypeText = Object.keys(listTypeTextObj).map((x) => {
          return listTypeTextObj[x];
        });
        this.listTypeText = listTypeText;
        this.getFieldGuarantee();
      }
    });
  }

  getFieldGuarantee() {
    this.numberField = 0;
    this.listField = [];
    this.numberObj = {};
    this.listType = [];
    this.listFieldData = [];
    this.haveNew = false;
    this.stampService.getFieldGuarantee().subscribe((res) => {
      if (!res.error) {
        this.showField(res.data);
        this.haveNew = false;
      }
    });
  }

  showField(listData: any) {
    if (listData.length > 0) {
      for (let i = 0; i < listData.length; i++) {
        let index = this.listTypeText.findIndex(
          (x) => x.type == listData[i].type
        );
        this.addFieldData(index, listData[i], i);
      }
    }
  }

  addFieldData(type, fieldData, indexField) {
    if (fieldData) {
      this.listFieldData.push(fieldData);
    }
    this.numberField++;
    let id = this.ramdomIdField(this.numberField);
    while (this.listField.indexOf(id) > -1) {
      id = this.ramdomIdField(this.numberField);
    }
    this.numberObj['selectBox' + id] = 0;
    this.numberObj['listSelectBox' + id] = [];
    this.numberObj['listSelectBoxKey' + id] = [];
    this.numberObj['checkBox' + id] = 0;
    this.numberObj['listCheckBox' + id] = [];
    this.numberObj['listCheckBoxKey' + id] = [];
    this.numberObj['radio' + id] = 0;
    this.numberObj['listRadio' + id] = [];
    this.numberObj['listRadioKey' + id] = [];
    $('#fields').append(
      `
    <div id="fieldBoder` +
      id +
      `" class="col-6 " style="margin-top: 1.0715rem; position: relative">
      <div id="fieldContent` +
      id +
      `" class="col-12 form-horizontal p-10 pl-30 pr-30 mb-15" style="border: 1px solid #dcdcdc; margin-left: -1.0715rem; box-shadow: 0 4px 12px rgba(1,1,1,0.2); border-radius: 4px; background: #fafafa;">
      </div>
    <i id="` +
      'updateField' +
      id +
      `" class="icon wb-pencil showUpdate" style="position: absolute; top: 5px; right: 35px; cursor: pointer;"></i>
    </div>
    `
    );
    $('#fieldBoder' + id).addClass('field');
    this.listField.push(id);
    switch (type) {
      case 0: {
        that.listType.push(0);
        that.addTextInputData(id, this.listFieldData[indexField]);
        break;
      }
      case 1: {
        that.listType.push(1);
        that.addTextAreaData(id, this.listFieldData[indexField]);
        break;
      }
      case 2: {
        that.listType.push(2);
        that.addSelectBoxData(id, this.listFieldData[indexField]);
        break;
      }
      case 3: {
        that.listType.push(3);
        that.addRadioData(id, this.listFieldData[indexField]);
        break;
      }
      case 4: {
        that.listType.push(4);
        that.addCheckBoxData(id, this.listFieldData[indexField]);
        break;
      }
      case 5: {
        that.listType.push(5);
        that.addTextInputDataDate(id, this.listFieldData[indexField]);
        break;
      }
    }

    $('#' + 'updateField' + id.toString()).click(function (res) {
      $('#fieldBoder' + id).removeClass('field');
      var index = parseInt(
        res.currentTarget.id.toString().split('updateField')[1]
      );
      for (let i = 0; i < that.listField.length; i++) {
        if (that.listField[i] == index) {
          $('#' + 'fieldContent' + index).empty();
          switch (that.listType[i]) {
            case 0: {
              that.addTextInput(id, indexField);
              break;
            }
            case 1: {
              that.addTextArea(id, indexField);
              break;
            }
            case 2: {
              that.numberObj['selectBox' + id] = 0;
              that.numberObj['listSelectBox' + id] = [];
              that.numberObj['listSelectBoxKey' + id] = [];
              that.addSelectBox(id, indexField);
              break;
            }
            case 3: {
              that.numberObj['radio' + id] = 0;
              that.numberObj['listRadio' + id] = [];
              that.numberObj['listRadioKey' + id] = [];
              that.addRadio(id, indexField);
              break;
            }
            case 4: {
              that.numberObj['listCheckBox' + id] = [];
              that.numberObj['listCheckBoxKey' + id] = [];
              that.numberObj['checkBox' + id] = 0;
              that.addCheckBox(id, indexField);
              break;
            }
            case 5: {
              that.addTextInputDate(id, indexField);
              break;
            }
          }
        }
      }
      that.item = null;
    });
  }

  addField(type) {
    this.haveNew = true;
    this.listFieldData.push(null);
    this.numberField++;
    let id = this.ramdomIdField(this.numberField);
    while (this.listField.indexOf(id) > -1) {
      id = this.ramdomIdField(this.numberField);
    }
    this.numberObj['selectBox' + id] = 0;
    this.numberObj['listSelectBox' + id] = [];
    this.numberObj['listSelectBoxKey' + id] = [];
    this.numberObj['checkBox' + id] = 0;
    this.numberObj['listCheckBox' + id] = [];
    this.numberObj['listCheckBoxKey' + id] = [];
    this.numberObj['radio' + id] = 0;
    this.numberObj['listRadio' + id] = [];
    this.numberObj['listRadioKey' + id] = [];
    $('#fields').append(
      `
    <div id="fieldBoder` +
      id +
      `" class="col-6" style="margin-top: 1.0715rem; position: relative">
      <div id="fieldContent` +
      id +
      `" class="col-12 form-horizontal p-10 pl-30 pr-30 mb-15" style="border: 1px solid #a5a2e8; margin-left: -1.0715rem;  box-shadow: 0 4px 12px rgba(1,1,1,0.2); border-radius: 4px;">
      </div>
    <i id="` +
      'closeField' +
      id +
      `" class="icon wb-close" style="position: absolute; top: 5px; right: 35px; cursor: pointer; color: red;"></i>
    </div>
    `
    );
    this.listField.push(id);
    switch (type) {
      case 0: {
        that.listType.push(0);
        that.addTextInput(id);
        break;
      }
      case 1: {
        that.listType.push(1);
        that.addTextArea(id);
        break;
      }
      case 2: {
        that.listType.push(2);
        that.addSelectBox(id);
        break;
      }
      case 3: {
        that.listType.push(3);
        that.addRadio(id);
        break;
      }
      case 4: {
        that.listType.push(4);
        that.addCheckBox(id);
        break;
      }
      case 5: {
        that.listType.push(5);
        that.addTextInputDate(id);
        break;
      }
    }

    $('#' + 'closeField' + id.toString()).click(function (res) {
      var index = parseInt(
        res.currentTarget.id.toString().split('closeField')[1]
      );
      for (let i = 0; i < that.listField.length; i++) {
        if (that.listField[i] == index) {
          $('#' + 'fieldBoder' + index.toString()).remove();
          that.listField.splice(i, 1);
          that.listType.splice(i, 1);
          that.listFieldData.splice(i, 1);
          delete that.numberObj['selectBox' + id];
          delete that.numberObj['listSelectBox' + id];
          delete that.numberObj['checkBox' + id];
          delete that.numberObj['listCheckBox' + id];
          delete that.numberObj['radio' + id];
          delete that.numberObj['listRadio' + id];
          that.numberField--;
          let h = that.listFieldData.indexOf(null);
          h && h != -1 ? (that.haveNew = true) : (that.haveNew = false);
        }
      }
    });
  }

  ramdomIdField(max) {
    return Math.floor(Math.random() * max + 1);
  }

  addTextInput(id, indexField) {
    let html =
      `
        <div class="row">
          <div class="col-6">
            <div class="form-group form-material">
              <input id="fieldName${id}"
                     type="text"
                     class="form-control"
                     placeholder="${that.translate.instant('NHAP_TEN_TRUONG')}">
              <small id="validateName${id}" style="color: red"></small>
              <div style="position: absolute; right: -100px; top: -5px; z-index: 9999; width: 71px">
                      <input id="required${id}" type="checkbox" checked style="cursor: pointer">
                      <label for="required${id}">${that.translate.instant('BAT_BUOC')}</label>
              </div>
              <div style="position: absolute; right: -100px; top: 20px; z-index: 9999; width: 71px">
                      <input id="showField${id}" type="checkbox" checked style="cursor: pointer">
                      <label for="showField${id}">${that.translate.instant('HIEN_THI')}</label>
              </div>
            </div>
          </div>
    `;
    if (this.listFieldData[indexField]) {
      html +=
        `
          <div class="col-6">
                  <div class="btn-group float-right">
                        <button type="button"
                                id="btnUpdate${id}"
                                class="btn btn-icon btn-primary"
                                tooltip="${that.translate.instant('CAP_NHAT')}">
                          <i class="fas fa-save" aria-hidden="true"></i>
                        </button>
                        <button type="button"
                                id="cancelUpdate${id}"
                                class="btn btn-icon btn-default">
                          <i class="icon wb-close" aria-hidden="true"></i>
                        </button>
                  </div>
              </div>
    `;
    }
    html += `
          </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group" style="position: relative">
              <input type="text"
                     class="form-control"
                     placeholder="${that.translate.instant('NHAP_DU_LIEU')}">
          </div>
        </div>
      </div>
    `;
    $('#fieldContent' + id).append(html);
    $('#fieldName' + id).focusout(function () {
      if ($('#fieldName' + id).val()) {
        $('#validateName' + id).text('');
      } else {
        $('#validateName' + id).text(that.translate.instant('TEN_TRUONG_KHONG_DUOC_DE_TRONG'));
      }
    });
    $('#fieldName' + id).click(function () {
      $('#validateName' + id).text('');
    });

    if (this.listFieldData[indexField]) {
      $('#fieldName' + id).val(this.listFieldData[indexField].name);
      if (this.listFieldData[indexField].require == 1) {
        $('#required' + id).prop('checked', true);
      } else {
        $('#required' + id).prop('checked', false);
      }
      if (this.listFieldData[indexField].status == 1) {
        $('#showField' + id).prop('checked', true);
      } else {
        $('#showField' + id).prop('checked', false);
      }
      $('#btnUpdate' + id).click(() => {
        that.updateInput(id, indexField);
      });
      $('#cancelUpdate' + id).click(() => {
        $('#' + 'fieldContent' + id).empty();
        that.addTextInputData(id, this.listFieldData[indexField]);
        $('#fieldBoder' + id).addClass('field');
      });
    }
  }

  updateInput(id, indexField) {
    let item: any = {};
    item.id = this.listFieldData[indexField].id;
    item.type = 0;
    item.name = $('#fieldName' + id).val();
    item.require = $('#required' + id).prop('checked') ? 1 : 0;
    item.status = $('#showField' + id).prop('checked') ? 1 : 0;
    item.value = null;
    if (!item.name) {
      $('#validateName' + id).text(that.translate.instant('TEN_TRUONG_KHONG_DUOC_DE_TRONG'));
    } else {
      this.stampService.updateFieldGuarantee(item).subscribe((res) => {
        if (!res.error) {
          $('#' + 'fieldContent' + id).empty();
          item.key = this.listFieldData[indexField].key;
          this.listFieldData[indexField] = item;
          this.addTextInputData(id, item);
          $('#fieldBoder' + id).addClass('field');
        }
      });
    }
  }

  addTextInputData(id, data) {
    let html =
      `
         <div class="row" style="position: relative">
        <div class="col-12">
          <label>${data.name}`;
    if (data.require == 1) {
      html += `<span style="color: red"> (*)</span>`;
    }
    if (data.status) {
      html += `
      </label>
      <div class="form-group" style="width: 50%">
        <input type="text"
               class="form-control"
               placeholder="${that.translate.instant('NHAP_DU_LIEU')}">
      </div>
    </div>
    <span style="position: absolute;top: -5px;right: 20px;font-size: 12px;" class="badge badge-info">${that.translate.instant('HIEN_THI')}</span>
  </div>
  `;
    } else {
      html += `
      </label>
      <div class="form-group" style="width: 50%">
        <input type="text"
               class="form-control"
               placeholder="${that.translate.instant('NHAP_DU_LIEU')}">
      </div>
    </div>
    <span style="position: absolute;top: -5px;right: 20px;font-size: 12px;" class="badge badge-default">${that.translate.instant('AN')}</span>
  </div>
  `;
    }

    $('#fieldContent' + id).append(html);
  }

  addTextInputDate(id, indexField) {
    let html =
      `
        <div class="row">
          <div class="col-6">
            <div class="form-group form-material">
              <input id="fieldName` +
      id +
      `" type="text" class="form-control" placeholder="\" + that.translate.instant('NHAP_TEN_TRUONG') + \"\">
              <small id="validateName` +
      id +
      `" style="color: red"></small>
              <div  style="position: absolute ;right: -100px; top: -5px; z-index: 9999">
                      <input id="required` +
      id +
      `" type="checkbox" checked="" style="cursor: pointer" >
                      <label for="inputChecked">" + that.translate.instant('BAT_BUOC') + "</label>
              </div>
              <div  style="position: absolute ;right: -100px; top: 20px; z-index: 9999; width: 71px">
                      <input id="showField` +
      id +
      `" type="checkbox" checked="" style="cursor: pointer">
                      <label for="inputChecked">" + that.translate.instant('HIEN_THI') + "</label>
              </div>
            </div>
          </div>
    `;
    if (this.listFieldData[indexField]) {
      html +=
        `
          <div class="col-6">
                  <div class="btn-group float-right">
                        <button type="button" id="btnUpdate` +
        id +
        `" class="btn btn-icon btn-primary" tooltip="\" + that.translate.instant('CAP_NHAT') + \"\"><i class="fas fa-save" aria-hidden="true"></i></button>
                        <button type="button" id="cancelUpdate` +
        id +
        `" class="btn btn-icon btn-default"><i class="icon wb-close" aria-hidden="true"></i></button>
                  </div>
              </div>
    `;
    }
    html +=
      `
          </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group" style="position: relative">
              <input id="inputDate` +
      id +
      `" type="text" class="form-control" placeholder="\" + that.translate.instant('CHON_NGAY') + \"\">
          </div>
        </div>
      </div>
    `;
    $('#fieldContent' + id).append(html);
    $('#inputDate' + id).datepicker('dd/mm/yyyy');
    $('#fieldName' + id).focusout(function () {
      if ($('#fieldName' + id).val()) {
        $('#validateName' + id).text('');
      } else {
        $('#validateName' + id).text(that.translate.instant('TEN_TRUONG_KHONG_DUOC_DE_TRONG'));
      }
    });
    $('#fieldName' + id).click(function () {
      $('#validateName' + id).text('');
    });

    if (this.listFieldData[indexField]) {
      $('#fieldName' + id).val(this.listFieldData[indexField].name);
      if (this.listFieldData[indexField].require == 1) {
        $('#required' + id).prop('checked', true);
      } else {
        $('#required' + id).prop('checked', false);
      }
      if (this.listFieldData[indexField].status == 1) {
        $('#showField' + id).prop('checked', true);
      } else {
        $('#showField' + id).prop('checked', false);
      }
      $('#btnUpdate' + id).click(() => {
        that.updateInputDate(id, indexField);
      });
      $('#cancelUpdate' + id).click(() => {
        $('#' + 'fieldContent' + id).empty();
        that.addTextInputDataDate(id, this.listFieldData[indexField]);
        $('#fieldBoder' + id).addClass('field');
      });
    }
  }

  updateInputDate(id, indexField) {
    let item: any = {};
    item.id = this.listFieldData[indexField].id;
    item.type = 5;
    item.name = $('#fieldName' + id).val();
    item.require = $('#required' + id).prop('checked') ? 1 : 0;
    item.status = $('#showField' + id).prop('checked') ? 1 : 0;
    item.value = null;
    if (!item.name) {
      $('#validateName' + id).text(that.translate.instant('TEN_TRUONG_KHONG_DUOC_DE_TRONG'));
    } else {
      this.stampService.updateFieldGuarantee(item).subscribe((res) => {
        if (!res.error) {
          $('#' + 'fieldContent' + id).empty();
          item.key = this.listFieldData[indexField].key;
          this.listFieldData[indexField] = item;
          this.addTextInputDataDate(id, item);
          $('#fieldBoder' + id).addClass('field');
        }
      });
    }
  }

  addTextInputDataDate(id, data) {
    let html =
      `
         <div class="row" style="position: relative">
        <div class="col-12">
          <label>${data.name}`;
    if (data.require == 1) {
      html += `<span style="color: red"> (*)</span>`;
    }
    if (data.status) {
      html +=
        `
        </label>
        <div class="form-group" style="width: 50%">
          <input id="inputDateData${id}"
                 type="text"
                 class="form-control"
                 placeholder="${that.translate.instant('CHON_NGAY')}">
        </div>
      </div>
      <span style="position: absolute;top: -5px;right: 20px;font-size: 12px;" class="badge badge-info">${that.translate.instant('HIEN_THI')}</span>
    </div>
    `;
    } else {
      html +=
        `
        </label>
        <div class="form-group" style="width: 50%">
          <input id="inputDateData${id}"
                 type="text"
                 class="form-control"
                 placeholder="${that.translate.instant('CHON_NGAY')}">
        </div>
      </div>
      <span style="position: absolute;top: -5px;right: 20px;font-size: 12px;" class="badge badge-default">${that.translate.instant('AN')}</span>
    </div>
    `;
    }

    $('#fieldContent' + id).append(html);
    $('#inputDateData' + id).datepicker('dd/mm/yyyy');
  }

  addTextArea(id, indexField) {
    let html =
      `
        <div class="row">
          <div class="col-6">
            <div class="form-group form-material">
              <input id="fieldName` +
      id +
      `" type="text" class="form-control" placeholder="\" + that.translate.instant('NHAP_TEN_TRUONG') + \"\">
               <small id="validateName` +
      id +
      `" style="color: red"></small>
              <div  style="position: absolute ;right: -100px; top: -5px; z-index: 9999">
                      <input id="required` +
      id +
      `" type="checkbox" checked="" style="cursor: pointer">
                      <label for="inputChecked">" + that.translate.instant('BAT_BUOC') + "</label>
              </div>
              <div  style="position: absolute ;right: -100px; top: 20px; z-index: 9999; width: 71px">
                      <input id="showField` +
      id +
      `" type="checkbox" checked="" style="cursor: pointer">
                      <label for="inputChecked">" + that.translate.instant('HIEN_THI') + "</label>
              </div>
            </div>
          </div>
    `;
    if (this.listFieldData[indexField]) {
      html +=
        `
          <div class="col-6">
                  <div class="btn-group float-right">
                        <button type="button" id="btnUpdate` +
        id +
        `" class="btn btn-icon btn-primary" tooltip="\" + that.translate.instant('CAP_NHAT') + \"\"><i class="fas fa-save" aria-hidden="true"></i></button>
                        <button type="button" id="cancelUpdate` +
        id +
        `" class="btn btn-icon btn-default"><i class="icon wb-close" aria-hidden="true"></i></button>
                  </div>
              </div>
    `;
    }
    html += `
          </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group" style="position: relative">
          <textarea  type="text" class="form-control" placeholder="\" + that.translate.instant('NHAP_DU_LIEU') + \"\"></textarea>
        </div>
      </div>
    `;
    $('#fieldContent' + id).append(html);
    $('#fieldName' + id).focusout(function () {
      if ($('#fieldName' + id).val()) {
        $('#validateName' + id).text('');
      } else {
        $('#validateName' + id).text(that.translate.instant('TEN_TRUONG_KHONG_DUOC_DE_TRONG'));
      }
    });
    $('#fieldName' + id).click(function () {
      $('#validateName' + id).text('');
    });

    if (this.listFieldData[indexField]) {
      $('#fieldName' + id).val(this.listFieldData[indexField].name);
      if (this.listFieldData[indexField].require == 1) {
        $('#required' + id).prop('checked', true);
      } else {
        $('#required' + id).prop('checked', false);
      }
      if (this.listFieldData[indexField].status == 1) {
        $('#showField' + id).prop('checked', true);
      } else {
        $('#showField' + id).prop('checked', false);
      }
      $('#btnUpdate' + id).click(() => {
        that.updateTextArea(id, indexField);
      });
      $('#cancelUpdate' + id).click(() => {
        $('#' + 'fieldContent' + id).empty();
        that.addTextAreaData(id, this.listFieldData[indexField]);
        $('#fieldBoder' + id).addClass('field');
      });
    }
  }

  updateTextArea(id, indexField) {
    let item: any = {};
    item.id = this.listFieldData[indexField].id;
    item.type = 1;
    item.name = $('#fieldName' + id).val();
    item.require = $('#required' + id).prop('checked') ? 1 : 0;
    item.status = $('#showField' + id).prop('checked') ? 1 : 0;
    item.value = null;
    if (!item.name) {
      $('#validateName' + id).text(that.translate.instant('TEN_TRUONG_KHONG_DUOC_DE_TRONG'));
    } else {
      this.stampService.updateFieldGuarantee(item).subscribe((res) => {
        if (!res.error) {
          $('#' + 'fieldContent' + id).empty();
          item.key = this.listFieldData[indexField].key;
          this.listFieldData[indexField] = item;
          this.addTextInputData(id, item);
          $('#fieldBoder' + id).addClass('field');
        }
      });
    }
  }

  addTextAreaData(id, data) {
    let html =
      `
         <div class="row" style="position: relative">
        <div class="col-12">
          <label>${data.name}`;
    if (data.require == 1) {
      html += `<span style="color: red"> (*)</span>`;
    }
    if (data.status) {
      html += `
      </label>
      <div class="form-group" style="width: 50%">
      <textarea type="text"
                class="form-control"
                placeholder="${that.translate.instant('NHAP_DU_LIEU')}"></textarea>
      </div>
    </div>
    <span style="position: absolute;top: -5px;right: 20px;font-size: 12px;" class="badge badge-info">${that.translate.instant('HIEN_THI')}</span>
  </div>
  `;
    } else {
      html += `
      </label>
      <div class="form-group" style="width: 50%">
      <textarea type="text"
                class="form-control"
                placeholder="${that.translate.instant('NHAP_DU_LIEU')}"></textarea>
      </div>
    </div>
    <span style="position: absolute;top: -5px;right: 20px;font-size: 12px;" class="badge badge-default">${that.translate.instant('AN')}</span>
  </div>
  `;
    }

    $('#fieldContent' + id).append(html);
  }

  addSelectBox(id, indexField) {
    let html =
      `
        <div class="row">
              <div class="col-6 form-group form-material">
                  <input id="fieldName${id}"
                         type="text"
                         class="form-control"
                         placeholder="${that.translate.instant('NHAP_TEN_TRUONG')}">
                   <small id="validateName${id}" style="color: red"></small>
                  <div  style="position: absolute ;right: -100px; top: -5px; z-index: 9999">
                          <input id="required${id}" type="checkbox" style="cursor: pointer" checked>
                          <label for="required${id}">${that.translate.instant('BAT_BUOC')}</label>
                  </div>
                  <div  style="position: absolute ;right: -100px; top: 20px; z-index: 9999; width: 71px">
                      <input id="showField${id}" type="checkbox" checked style="cursor: pointer">
                      <label for="showField${id}">${that.translate.instant('HIEN_THI')}</label>
              </div>
              </div>
    `;
    if (this.listFieldData[indexField]) {
      html +=
        `
          <div class="col-6">
                  <div class="btn-group float-right">
                        <button type="button"
                                id="btnUpdate${id}"
                                class="btn btn-icon btn-primary"
                                tooltip="${that.translate.instant('CAP_NHAT')}">
                          <i class="fas fa-save" aria-hidden="true"></i>
                        </button>
                        <button type="button"
                                id="cancelUpdate${id}"
                                class="btn btn-icon btn-default">
                          <i class="icon wb-close" aria-hidden="true"></i>
                        </button>
                  </div>
              </div>
    `;
    }
    html +=
      `
        </div>
          <div class="row">
              <div class="col-6 form-group" style="position: relative;">
                <div class="btn-group bootstrap-select show" style="width: 100%">
                            <button type="button"
                                    class="btn dropdown-toggle btn-select"
                                    title="${that.translate.instant('LUA_CHON')}">
                                <span class="filter-option pull-left">${that.translate.instant('LUA_CHON')}</span>&nbsp;<span class="bs-caret"><span class="caret"></span></span>
                            </button>
                            <div id="selectOption` +
      id +
      `" class="select-dropdown-menu dropdown-menu-primary">

                            </div>
                            <div id="addOptionSelect` +
      id +
      `" class="form-horizontal add-new p-10 pl-10 mb-15 mt-2">
                              <i class="icon wb-plus" style="margin: auto; font-size: 10px;"></i>
                            </div>
                          </div>
              </div>
          </div>
    `;
    $('#fieldContent' + id).append(html);
    $('#fieldName' + id).focusout(function () {
      if ($('#fieldName' + id).val()) {
        $('#validateName' + id).text('');
      } else {
        $('#validateName' + id).text(that.translate.instant('TEN_TRUONG_KHONG_DUOC_DE_TRONG'));
      }
    });
    $('#fieldName' + id).click(function () {
      $('#validateName' + id).text('');
    });

    $('#addOptionSelect' + id).click(function () {
      that.addSelectOption(id);
    });
    if (this.listFieldData[indexField]) {
      this.addSelectOption(id, indexField, 1);
    } else {
      this.addSelectOption(id, null, 1);
    }
    if (this.listFieldData[indexField]) {
      $('#fieldName' + id).val(this.listFieldData[indexField].name);
      if (this.listFieldData[indexField].require == 1) {
        $('#required' + id).prop('checked', true);
      } else {
        $('#required' + id).prop('checked', false);
      }
      if (this.listFieldData[indexField].status == 1) {
        $('#showField' + id).prop('checked', true);
      } else {
        $('#showField' + id).prop('checked', false);
      }
      $('#btnUpdate' + id).click(() => {
        that.updateSelectBox(id, indexField);
      });
      $('#cancelUpdate' + id).click(() => {
        $('#' + 'fieldContent' + id).empty();
        that.addSelectBoxData(id, this.listFieldData[indexField]);
        $('#fieldBoder' + id).addClass('field');
      });
    }
  }

  addSelectOption(id, indexField, first?) {
    if (this.listFieldData[indexField]) {
      if (Object.keys(this.listFieldData[indexField].value).length > 0) {
        let listData = Object.keys(this.listFieldData[indexField].value).map(
          (x) => this.listFieldData[indexField].value[x]
        );
        for (let i = 0; i < listData.length; i++) {
          this.numberObj['selectBox' + id]++;
          this.numberObj['listSelectBoxKey' + id].push(i);
          let idOption = this.ramdomIdField(this.numberObj['selectBox' + id]);
          while (this.numberObj['listSelectBox' + id].indexOf(idOption) > -1) {
            idOption = this.ramdomIdField(this.numberObj['selectBox' + id]);
          }
          let html =
            `
              <a id="optionSelect` +
            idOption +
            `" class="dropdown-item" href="javascript:void(0)" style="position: relative">
              <div class="form-group form-material" style="margin-top: 0px; margin-bottom: 0px;">
                <input id="selectValue` +
            idOption +
            `" type="text" class="form-control" placeholder="\" + that.translate.instant('NHAP_GIA_TRI') + \"\" style="padding-right: 20px;" value="` +
            listData[i].value +
            `" />
                <small id="selectValueValidate` +
            idOption +
            `" style="color: red"></small>
                </div>

          `;
          if (listData[i].isVisible) {
            html +=
              `<i id="show` +
              idOption +
              `" class="wb wb-eye float-right" style="position: absolute; right: 15px; top: 15px; color: #061178;"></i>`;
          } else {
            html +=
              `<i id="hide` +
              idOption +
              `" class="wb wb-eye-close float-right" style="position: absolute; right: 15px; top: 15px;"></i>`;
          }
          html += `</a>`;
          $('#selectOption' + id).append(html);
          this.numberObj['listSelectBox' + id].push(idOption);
          $('#' + 'closeOptionSelect' + idOption).click(function (res) {
            var index = parseInt(
              res.currentTarget.id.toString().split('closeOptionSelect')[1]
            );
            for (
              let i = 0;
              i < that.numberObj["listSelectBox" + id].length;
              i++
            ) {
              if (that.numberObj['listSelectBox' + id][i] == index) {
                $('#' + 'optionSelect' + index).remove();
                that.numberObj['listSelectBox' + id].splice(i, 1);
                that.numberObj['listSelectBoxKey' + id].splice(i, 1);
                that.numberObj['selectBox' + id]--;
              }
            }
          });
          $('#selectValue' + idOption).click(() => {
            $('#selectValueValidate' + idOption).text('');
          });
          $('#selectValue' + idOption).focusout(() => {
            if ($('#selectValue' + idOption).val()) {
              $('#selectValueValidate' + idOption).text('');
            } else {
              $('#selectValueValidate' + idOption).text(that.translate.instant('KHONG_DUOC_DE_TRONG'));
            }
          });
          if (listData[i].isVisible) {
            this.showSelectOption(id, idOption);
            $('#selectValue' + idOption).attr('isVisible', 1);
          } else {
            this.hideSelectOption(id, idOption);
            $('#selectValue' + idOption).attr('isVisible', 2);
          }
        }
      }
    } else {
      if (first) {
        this.numberObj['selectBox' + id]++;
        this.numberObj['listSelectBoxKey' + id].push(null);
        let idOption = this.ramdomIdField(this.numberObj['selectBox' + id]);
        while (this.numberObj['listSelectBox' + id].indexOf(idOption) > -1) {
          idOption = this.ramdomIdField(this.numberObj['selectBox' + id]);
        }
        $('#selectOption' + id).append(
          `
      <a id="optionSelect` +
          idOption +
          `" class="dropdown-item" href="javascript:void(0)" style="position: relative">
         <div class="form-group form-material" style="margin-top: 0px; margin-bottom: 0px;">
            <input id="selectValue` +
          idOption +
          `" type="text" class="form-control" placeholder="\" + that.translate.instant('NHAP_GIA_TRI') + \"\" style="padding-right: 20px;" />
            <small id="selectValueValidate` +
          idOption +
          `" style="color: red"></small>
         </div>
      </a>
        `
        );
        this.numberObj['listSelectBox' + id].push(idOption);
        $('#' + 'closeOptionSelect' + idOption).click(function (res) {
          var index = parseInt(
            res.currentTarget.id.toString().split('closeOptionSelect')[1]
          );
          for (
            let i = 0;
            i < that.numberObj["listSelectBox" + id].length;
            i++
          ) {
            if (that.numberObj['listSelectBox' + id][i] == index) {
              $('#' + 'optionSelect' + index).remove();
              that.numberObj['listSelectBox' + id].splice(i, 1);
              that.numberObj['listSelectBoxKey' + id].splice(i, 1);
              that.numberObj['selectBox' + id]--;
            }
          }
        });

        $('#selectValue' + idOption).click(() => {
          $('#selectValueValidate' + idOption).text('');
        });
        $('#selectValue' + idOption).focusout(() => {
          if ($('#selectValue' + idOption).val()) {
            $('#selectValueValidate' + idOption).text('');
          } else {
            $('#selectValueValidate' + idOption).text(that.translate.instant('KHONG_DUOC_DE_TRONG'));
          }
        });
      } else {
        this.numberObj['selectBox' + id]++;
        this.numberObj['listSelectBoxKey' + id].push(null);
        let idOption = this.ramdomIdField(this.numberObj['selectBox' + id]);
        while (this.numberObj['listSelectBox' + id].indexOf(idOption) > -1) {
          idOption = this.ramdomIdField(this.numberObj['selectBox' + id]);
        }
        $('#selectOption' + id).append(
          `
    <a id="optionSelect` +
          idOption +
          `" class="dropdown-item" href="javascript:void(0)" style="position: relative">
       <div class="form-group form-material" style="margin-top: 0px; margin-bottom: 0px;">
          <input id="selectValue` +
          idOption +
          `" type="text" class="form-control" placeholder="\" + that.translate.instant('NHAP_GIA_TRI') + \"\" style="padding-right: 20px;" />
          <small id="selectValueValidate` +
          idOption +
          `" style="color: red"></small>
       </div>
       <i id="closeOptionSelect` +
          idOption +
          `" class="wb wb-close float-right showButton" style="position: absolute; right: 15px; top: 15px"></i>
    </a>
      `
        );
        this.numberObj['listSelectBox' + id].push(idOption);
        $('#' + 'closeOptionSelect' + idOption).click(function (res) {
          var index = parseInt(
            res.currentTarget.id.toString().split('closeOptionSelect')[1]
          );
          for (
            let i = 0;
            i < that.numberObj["listSelectBox" + id].length;
            i++
          ) {
            if (that.numberObj['listSelectBox' + id][i] == index) {
              $('#' + 'optionSelect' + index).remove();
              that.numberObj['listSelectBox' + id].splice(i, 1);
              that.numberObj['listSelectBoxKey' + id].splice(i, 1);
              that.numberObj['selectBox' + id]--;
            }
          }
        });

        $('#selectValue' + idOption).click(() => {
          $('#selectValueValidate' + idOption).text('');
        });
        $('#selectValue' + idOption).focusout(() => {
          if ($('#selectValue' + idOption).val()) {
            $('#selectValueValidate' + idOption).text('');
          } else {
            $('#selectValueValidate' + idOption).text(that.translate.instant('KHONG_DUOC_DE_TRONG'));
          }
        });
      }
    }
  }

  showSelectOption(id, idOption) {
    $('#show' + idOption).click(function () {
      $('#show' + idOption).remove();
      $('#optionSelect' + idOption).append(
        `<i id="hide` +
        idOption +
        `" class="wb wb-eye-close float-right" style="position: absolute; right: 15px; top: 15px;"></i>`
      );
      $('#selectValue' + idOption).attr('isVisible', 2);
      that.hideSelectOption(id, idOption);
    });
  }

  hideSelectOption(id, idOption) {
    $('#hide' + idOption).click(function () {
      $('#hide' + idOption).remove();
      $('#optionSelect' + idOption).append(
        `<i id="show` +
        idOption +
        `" class="wb wb-eye float-right" style="position: absolute; right: 15px; top: 15px; color: #061178;"></i>`
      );
      $('#selectValue' + idOption).attr('isVisible', 1);
      that.showSelectOption(id, idOption);
    });
  }

  updateSelectBox(id, indexField) {
    let item: any = {};
    item.id = this.listFieldData[indexField].id;
    item.type = 2;
    item.name = $('#fieldName' + id).val();
    item.require = $('#required' + id).prop('checked') ? 1 : 0;
    item.status = $('#showField' + id).prop('checked') ? 1 : 0;
    item.value = '';
    let listSelectBox = this.numberObj['listSelectBox' + id];
    if (listSelectBox.length > 0) {
      let option: any = [];
      let h = 0;
      for (let sl = 0; sl < listSelectBox.length; sl++) {
        if (!$('#selectValue' + listSelectBox[sl]).val()) {
          $('#selectValueValidate' + listSelectBox[sl]).text(
            that.translate.instant('KHONG_DUOC_DE_TRONG')
          );
          h++;
        }
        let _item: any = {
          value: $('#selectValue' + listSelectBox[sl]).val(),
        };
        if ($('#selectValue' + listSelectBox[sl]).attr('isvisible') == 1) {
          _item.isVisible = 1;
        } else if (
          $('#selectValue' + listSelectBox[sl]).attr('isvisible') == 2
        ) {
          _item.isVisible = 0;
        } else {
          _item.isVisible = 1;
        }
        if (
          this.numberObj['listSelectBoxKey' + id][sl] ||
          this.numberObj['listSelectBoxKey' + id][sl] == 0
        ) {
          _item.key = that.numberObj['listSelectBoxKey' + id][sl];
        }
        option.push(_item);
      }
      item.value = option;
      if (!item.name) {
        $('#validateName' + id).text(that.translate.instant('TEN_TRUONG_KHONG_DUOC_DE_TRONG'));
      }
      if (item.name && h == 0) {
        this.stampService.updateFieldGuarantee(item).subscribe((res) => {
          if (!res.error) {
            $('#' + 'fieldContent' + id).empty();
            item.key = this.listFieldData[indexField].key;
            this.listFieldData[indexField] = item;
            this.addSelectBoxData(id, item);
            $('#fieldBoder' + id).addClass('field');
          }
        });
      }
      //console.log(item)
    }
  }

  addSelectBoxData(id, data) {
    let listData = Object.keys(data.value).map((x) => data.value[x]);
    let html = '';
    html +=
      `
      <div class="row" style="position: relative">
        <div class="col-6">
          <div class="form-group">
            <label>${data.name}
    `;
    if (data.require == 1) {
      html += `<span style="color: red"> (*)</span>`;
    }
    html += `</label>
    <select class="form-control">
    <option>${that.translate.instant('LUA_CHON')}</option>`;
    for (let i = 0; i < listData.length; i++) {
      if (listData[i].isVisible == 1) {
        html += `<option>` + listData[i].value + `</option>`;
      }
    }
    if (data.status) {
      html += `
      </select>
      </div>
    </div>
    <span style="position: absolute;top: -5px;right: 20px;font-size: 12px;" class="badge badge-info">${that.translate.instant('HIEN_THI')}</span>
  </div>
`;
    } else {
      html += `
      </select>
      </div>
    </div>
    <span style="position: absolute;top: -5px;right: 20px;font-size: 12px;" class="badge badge-default">${that.translate.instant('AN')}</span>
  </div>
`;
    }

    $('#fieldContent' + id).append(html);
  }

  addCheckBox(id, indexField) {
    let html =
      `
      <div class="row">
            <div class="col-6 form-group form-material">
              <input id="fieldName${id}"
                     type="text"
                     class="form-control"
                     placeholder="${that.translate.instant('NHAP_TEN_TRUONG')}">
               <small id="validateName${id}" style="color: red"></small>
                   <div  style="position: absolute ;right: -100px; top: -5px; z-index: 9999">
                      <input id="required${id}" type="checkbox" style="cursor: pointer" checked>
                      <label for="required${id}">${that.translate.instant('BAT_BUOC')}</label>
                  </div>
                  <div  style="position: absolute ;right: -100px; top: 20px; z-index: 9999; width: 71px">
                      <input id="showField${id}" type="checkbox" checked style="cursor: pointer">
                      <label for="showField${id}">${that.translate.instant('HIEN_THI')}</label>
              </div>
              </div>
    `;
    if (this.listFieldData[indexField]) {
      html +=
        `
          <div class="col-6">
                  <div class="btn-group float-right">
                        <button type="button"
                                id="btnUpdate${id}"
                                class="btn btn-icon btn-primary"
                                tooltip="${that.translate.instant('CAP_NHAT')}">
                          <i class="fas fa-save" aria-hidden="true"></i>
                        </button>
                        <button type="button"
                                id="cancelUpdate${id}"
                                class="btn btn-icon btn-default">
                          <i class="icon wb-close" aria-hidden="true"></i>
                        </button>
                  </div>
              </div>
    `;
    }
    html +=
      `
        </div>
          <div class="row" id="optionCheckBox` +
      id +
      `">

          </div>
          <div class="row">
              <div id="divAddOptionCheckBox` +
      id +
      `" class="col-6">
                  <div id="addOptionCheckBox` +
      id +
      `" class="form-horizontal add-new p-10 pl-10 mb-15">
                      <i class="icon wb-plus" style="margin: auto; font-size: 10px;"></i>
                  </div>
              </div>
          </div>
    `;
    $('#fieldContent' + id).append(html);
    $('#fieldName' + id).focusout(function () {
      if ($('#fieldName' + id).val()) {
        $('#validateName' + id).text('');
      } else {
        $('#validateName' + id).text(that.translate.instant('TEN_TRUONG_KHONG_DUOC_DE_TRONG'));
      }
    });
    $('#fieldName' + id).click(function () {
      $('#validateName' + id).text('');
    });

    $('#addOptionCheckBox' + id).click(function () {
      that.addCheckOption(id);
    });
    if (this.listFieldData[indexField]) {
      this.addCheckOption(id, indexField);
    } else {
      this.addCheckOption(id, null, 1);
    }
    if (this.listFieldData[indexField]) {
      $('#fieldName' + id).val(this.listFieldData[indexField].name);
      if (this.listFieldData[indexField].require == 1) {
        $('#required' + id).prop('checked', true);
      } else {
        $('#required' + id).prop('checked', false);
      }
      if (this.listFieldData[indexField].status == 1) {
        $('#showField' + id).prop('checked', true);
      } else {
        $('#showField' + id).prop('checked', false);
      }
      $('#btnUpdate' + id).click(() => {
        that.updateCheckBox(id, indexField);
      });
      $('#cancelUpdate' + id).click(() => {
        $('#' + 'fieldContent' + id).empty();
        that.addCheckBoxData(id, this.listFieldData[indexField]);
        $('#fieldBoder' + id).addClass('field');
      });
    }
  }

  addCheckOption(id, indexField, first?) {
    if (this.listFieldData[indexField]) {
      if (Object.keys(this.listFieldData[indexField].value).length > 0) {
        let listData = Object.keys(this.listFieldData[indexField].value).map(
          (x) => this.listFieldData[indexField].value[x]
        );
        for (let i = 0; i < listData.length; i++) {
          this.numberObj['checkBox' + id]++;
          this.numberObj['listCheckBoxKey' + id].push(i);
          let idOption = this.ramdomIdField(this.numberObj['checkBox' + id]);
          while (this.numberObj['listCheckBox' + id].indexOf(idOption) > -1) {
            idOption = this.ramdomIdField(this.numberObj['checkBox' + id]);
          }
          $('#divAddOptionCheckBox' + id).remove();
          let html =
          `
              <div id="itemCheckBox${idOption}" class="col-6">
                    <div id="itemOptionCheckbox${idOption}" class="checkbox-custom checkbox-primary">
                        <input type="checkbox" id="inputChecked" checked="">
                        <label for="inputChecked" style="width: 100%">
                            <div class="form-group form-material">
                                <input id="checkBoxValue${idOption}"
                                       type="text"
                                       class="form-control"
                                       value="${listData[i].value}"
                                       placeholder="${that.translate.instant('NHAP_DU_LIEU')}"
                                       style="margin-top: -13px; padding-right: 25px">
                                <small id="checkBoxValueValidate${idOption}" style="color: red"></small>
                                </div>
                        </label>
          `;
          if (listData[i].isVisible) {
            html +=
              `<i id="show` +
              idOption +
              `" class="wb wb-eye float-right" style="position: absolute; cursor: pointer; right: 5px; top: 0px;  color: #061178;"></i>`;
          } else {
            html +=
              `<i id="hide` +
              idOption +
              `" class="wb wb-eye-close float-right" style="position: absolute; cursor: pointer; right: 5px; top: 0px"></i>`;
          }
          html +=
            `
              </div>

            </div>
            <div id="divAddOptionCheckBox${id}" class="col-6">
                      <div id="addOptionCheckBox${id}" class="form-horizontal add-new p-10 pl-10 mb-15">
                          <i class="icon wb-plus" style="margin: auto; font-size: 10px;"></i>
                      </div>
             </div>
          `;
          $('#optionCheckBox' + id).append(html);
          $('#checkBoxValue' + idOption).click(() => {
            $('#checkBoxValueValidate' + idOption).text('');
          });
          $('#checkBoxValue' + idOption).focusout(() => {
            if ($('#checkBoxValue' + idOption).val()) {
              $('#checkBoxValueValidate' + idOption).text('');
            } else {
              $('#checkBoxValueValidate' + idOption).text(
                that.translate.instant('KHONG_DUOC_DE_TRONG')
              );
            }
          });
          this.numberObj['listCheckBox' + id].push(idOption);
          $('#addOptionCheckBox' + id).click(function () {
            that.addCheckOption(id);
          });
          $('#' + 'closeOptionCheckBox' + idOption).click(function (res) {
            var index = parseInt(
              res.currentTarget.id.toString().split('closeOptionCheckBox')[1]
            );
            for (
              let i = 0;
              i < that.numberObj["listCheckBox" + id].length;
              i++
            ) {
              if (that.numberObj['listCheckBox' + id][i] == index) {
                $('#' + 'itemCheckBox' + index).remove();
                that.numberObj['listCheckBox' + id].splice(i, 1);
                that.numberObj['listCheckBoxKey' + id].splice(i, 1);
                that.numberObj['checkBox' + id]--;
              }
            }
          });
          if (listData[i].isVisible) {
            this.showCheckBoxOption(id, idOption);
            $('#checkBoxValue' + idOption).attr('isVisible', 1);
          } else {
            this.hideCheckBoxOption(id, idOption);
            $('#checkBoxValue' + idOption).attr('isVisible', 2);
          }
        }
      }
    } else {
      if (first) {
        this.numberObj['checkBox' + id]++;
        this.numberObj['listCheckBoxKey' + id].push(null);
        let idOption = this.ramdomIdField(this.numberObj['checkBox' + id]);
        while (this.numberObj['listCheckBox' + id].indexOf(idOption) > -1) {
          idOption = this.ramdomIdField(this.numberObj['checkBox' + id]);
        }
        $('#divAddOptionCheckBox' + id).remove();
        $('#optionCheckBox' + id).append(
          `
            <div id="itemCheckBox${idOption}" class="col-6">
                    <div class="checkbox-custom checkbox-primary">
                        <input type="checkbox" id="inputChecked" checked="">
                        <label for="inputChecked" style="width: 100%">
                            <div class="form-group form-material">
                                <input id="checkBoxValue${idOption}"
                                       type="text"
                                       class="form-control"
                                       placeholder="${that.translate.instant('NHAP_DU_LIEU')}"
                                       style="margin-top: -13px; padding-right: 25px">
                                <small id="checkBoxValueValidate${idOption}" style="color: red"></small>
                            </div>
                        </label>

                    </div>

            </div>
            <div id="divAddOptionCheckBox${id}" class="col-6">
                      <div id="addOptionCheckBox${id}" class="form-horizontal add-new p-10 pl-10 mb-15">
                          <i class="icon wb-plus" style="margin: auto; font-size: 10px;"></i>
                      </div>
             </div>
        `
        );
        $('#checkBoxValue' + idOption).click(() => {
          $('#checkBoxValueValidate' + idOption).text('');
        });
        $('#checkBoxValue' + idOption).focusout(() => {
          if ($('#checkBoxValue' + idOption).val()) {
            $('#checkBoxValueValidate' + idOption).text('');
          } else {
            $('#checkBoxValueValidate' + idOption).text(that.translate.instant('KHONG_DUOC_DE_TRONG'));
          }
        });
        this.numberObj['listCheckBox' + id].push(idOption);
        $('#addOptionCheckBox' + id).click(function () {
          that.addCheckOption(id);
        });
        $('#' + 'closeOptionCheckBox' + idOption).click(function (res) {
          var index = parseInt(
            res.currentTarget.id.toString().split('closeOptionCheckBox')[1]
          );
          for (let i = 0; i < that.numberObj["listCheckBox" + id].length; i++) {
            if (that.numberObj['listCheckBox' + id][i] == index) {
              $('#' + 'itemCheckBox' + index).remove();
              that.numberObj['listCheckBox' + id].splice(i, 1);
              that.numberObj['listCheckBoxKey' + id].splice(i, 1);
              that.numberObj['checkBox' + id]--;
            }
          }
        });
      } else {
        this.numberObj['checkBox' + id]++;
        this.numberObj['listCheckBoxKey' + id].push(null);
        let idOption = this.ramdomIdField(this.numberObj['checkBox' + id]);
        while (this.numberObj['listCheckBox' + id].indexOf(idOption) > -1) {
          idOption = this.ramdomIdField(this.numberObj['checkBox' + id]);
        }
        $('#divAddOptionCheckBox' + id).remove();
        $('#optionCheckBox' + id).append(
          `
            <div id="itemCheckBox${idOption}" class="col-6">
                    <div class="checkbox-custom checkbox-primary">
                        <input type="checkbox" id="inputChecked" checked="">
                        <label for="inputChecked" style="width: 100%">
                            <div class="form-group form-material">
                                <input id="checkBoxValue${idOption}"
                                       type="text"
                                       class="form-control"
                                       placeholder="${that.translate.instant('NHAP_DU_LIEU')}"
                                       style="margin-top: -13px; padding-right: 25px">
                                <small id="checkBoxValueValidate${idOption}" style="color: red"></small>
                            </div>
                        </label>
                        <i id="closeOptionCheckBox${idOption}" class="wb wb-close float-right showButton" style="position: absolute; cursor: pointer; right: 5px; top: 0px"></i>
                    </div>

            </div>
            <div id="divAddOptionCheckBox${id}" class="col-6">
                      <div id="addOptionCheckBox${id}" class="form-horizontal add-new p-10 pl-10 mb-15">
                          <i class="icon wb-plus" style="margin: auto; font-size: 10px;"></i>
                      </div>
             </div>
        `
        );
        $('#checkBoxValue' + idOption).click(() => {
          $('#checkBoxValueValidate' + idOption).text('');
        });
        $('#checkBoxValue' + idOption).focusout(() => {
          if ($('#checkBoxValue' + idOption).val()) {
            $('#checkBoxValueValidate' + idOption).text('');
          } else {
            $('#checkBoxValueValidate' + idOption).text(that.translate.instant('KHONG_DUOC_DE_TRONG'));
          }
        });
        this.numberObj['listCheckBox' + id].push(idOption);
        $('#addOptionCheckBox' + id).click(function () {
          that.addCheckOption(id);
        });
        $('#' + 'closeOptionCheckBox' + idOption).click(function (res) {
          var index = parseInt(
            res.currentTarget.id.toString().split('closeOptionCheckBox')[1]
          );
          for (let i = 0; i < that.numberObj["listCheckBox" + id].length; i++) {
            if (that.numberObj['listCheckBox' + id][i] == index) {
              $('#' + 'itemCheckBox' + index).remove();
              that.numberObj['listCheckBox' + id].splice(i, 1);
              that.numberObj['listCheckBoxKey' + id].splice(i, 1);
              that.numberObj['checkBox' + id]--;
            }
          }
        });
      }
    }
  }

  showCheckBoxOption(id, idOption) {
    $('#show' + idOption).click(function () {
      $('#show' + idOption).remove();
      $('#itemOptionCheckbox' + idOption).append(
        `<i id="hide` +
        idOption +
        `" class="wb wb-eye-close float-right" style="position: absolute; cursor: pointer; right: 5px; top: 0px;"></i>`
      );
      $('#checkBoxValue' + idOption).attr('isVisible', 2);
      that.hideCheckBoxOption(id, idOption);
    });
  }

  hideCheckBoxOption(id, idOption) {
    $('#hide' + idOption).click(function () {
      $('#hide' + idOption).remove();
      $('#itemOptionCheckbox' + idOption).append(
        `<i id="show` +
        idOption +
        `" class="wb wb-eye float-right" style="position: absolute; cursor: pointer; right: 5px; top: 0px;  color: #061178;"></i>`
      );
      $('#checkBoxValue' + idOption).attr('isVisible', 1);
      that.showCheckBoxOption(id, idOption);
    });
  }

  updateCheckBox(id, indexField) {
    let item: any = {};
    item.id = this.listFieldData[indexField].id;
    item.type = 4;
    item.name = $('#fieldName' + id).val();
    item.require = $('#required' + id).prop('checked') ? 1 : 0;
    item.status = $('#showField' + id).prop('checked') ? 1 : 0;
    item.value = '';
    let listCheckBox = this.numberObj['listCheckBox' + id];
    if (listCheckBox.length > 0) {
      let option: any = [];
      let h = 0;
      for (let ck = 0; ck < listCheckBox.length; ck++) {
        if (!$('#checkBoxValue' + listCheckBox[ck]).val()) {
          $('#checkBoxValueValidate' + listCheckBox[ck]).text(
            that.translate.instant('KHONG_DUOC_DE_TRONG')
          );
          h++;
        }
        let _item: any = {
          value: $('#checkBoxValue' + listCheckBox[ck]).val(),
        };
        if ($('#checkBoxValue' + listCheckBox[ck]).attr('isvisible') == 1) {
          _item.isVisible = 1;
        } else if (
          $('#checkBoxValue' + listCheckBox[ck]).attr('isvisible') == 2
        ) {
          _item.isVisible = 0;
        } else {
          _item.isVisible = 1;
        }
        if (
          this.numberObj['listCheckBoxKey' + id][ck] ||
          this.numberObj['listCheckBoxKey' + id][ck] == 0
        ) {
          _item.key = that.numberObj['listCheckBoxKey' + id][ck];
        }
        option.push(_item);
      }
      item.value = option;
      if (!item.name) {
        $('#validateName' + id).text(that.translate.instant('TEN_TRUONG_KHONG_DUOC_DE_TRONG'));
      }
      if (item.name && h == 0) {
        this.stampService.updateFieldGuarantee(item).subscribe((res) => {
          if (!res.error) {
            $('#' + 'fieldContent' + id).empty();
            this.listFieldData[indexField] = item;
            this.addCheckBoxData(id, item);
            $('#fieldBoder' + id).addClass('field');
          }
        });
      }
    }
  }

  addCheckBoxData(id, data) {
    let listData = Object.keys(data.value).map((x) => data.value[x]);
    let html = '';
    html +=
      `
      <div class="row" style="position: relative">
        <div class="col-12">
          <div class="form-group">
            <label>${data.name}
    `;
    if (data.require == 1) {
      html += `<span style="color: red"> (*)</span>`;
    }
    html += `</label>
        <div class="list-unstyled list-inline">
    `;
    for (let i = 0; i < listData.length; i++) {
      if (listData[i].isVisible == 1) {
        html +=
          `<li class="list-inline-item">
      <div class="checkbox-custom checkbox-primary">
        <input type="checkbox" name="inputCheckboxes" checked="">
        <label>` +
          listData[i].value +
          `</label>
      </div>
    </li>
    `;
      }
    }
    if (data.status) {
      html += `
      </div>
    </div>
    <span style="position: absolute;top: -5px;right: 20px;font-size: 12px;" class="badge badge-info">${that.translate.instant('HIEN_THI')}</span>
</div>`;
    } else {
      html += `
      </div>
    </div>
    <span style="position: absolute;top: -5px;right: 20px;font-size: 12px;" class="badge badge-default">${that.translate.instant('AN')}</span>
</div>`;
    }

    $('#fieldContent' + id).append(html);
  }

  addRadio(id, indexField) {
    let html =
      `
        <div class="row">
            <div class="col-6 form-group form-material">
              <input id="fieldName${id}"
                     type="text"
                     class="form-control"
                     placeholder="${that.translate.instant('NHAP_TEN_TRUONG')}">
               <small id="validateName${id}" style="color: red"></small>
                  <div  style="position: absolute ;right: -100px; top: -5px; z-index: 9999">
                      <input id="required${id}" type="checkbox" style="cursor: pointer" checked>
                      <label for="required${id}">${that.translate.instant('BAT_BUOC')}</label>
                  </div>
                  <div  style="position: absolute ;right: -100px; top: 20px; z-index: 9999; width: 71px">
                      <input id="showField${id}" type="checkbox" checked style="cursor: pointer">
                      <label for="showField${id}">${that.translate.instant('HIEN_THI')}</label>
              </div>
            </div>
    `;
    if (this.listFieldData[indexField]) {
      html +=
        `
          <div class="col-6">
                  <div class="btn-group float-right">
                        <button type="button"
                                id="btnUpdate${id}"
                                class="btn btn-icon btn-primary"
                                tooltip="${that.translate.instant('CAP_NHAT')}">
                          <i class="fas fa-save" aria-hidden="true"></i>
                        </button>
                        <button type="button"
                                id="cancelUpdate${id}"
                                class="btn btn-icon btn-default">
                          <i class="icon wb-close" aria-hidden="true"></i>
                        </button>
                  </div>
              </div>
    `;
    }
    html +=
      `
      </div>
          <div class="row" id="optionRadio` +
      id +
      `">

          </div>
          <div class="row">
              <div id="divAddOptionRadio` +
      id +
      `" class="col-6">
                  <div id="addOptionRadio` +
      id +
      `" class="form-horizontal add-new p-10 pl-10 mb-15">
                      <i class="icon wb-plus" style="margin: auto; font-size: 10px;"></i>
                  </div>
              </div>
          </div>
    `;
    $('#fieldContent' + id).append(html);
    $('#fieldName' + id).focusout(function () {
      if ($('#fieldName' + id).val()) {
        $('#validateName' + id).text('');
      } else {
        $('#validateName' + id).text(that.translate.instant('TEN_TRUONG_KHONG_DUOC_DE_TRONG'));
      }
    });
    $('#fieldName' + id).click(function () {
      $('#validateName' + id).text('');
    });

    $('#addOptionRadio' + id).click(function () {
      that.addRadioOption(id);
    });
    if (this.listFieldData[indexField]) {
      that.addRadioOption(id, indexField);
    } else {
      that.addRadioOption(id, null, 1);
    }
    if (this.listFieldData[indexField]) {
      $('#fieldName' + id).val(this.listFieldData[indexField].name);
      if (this.listFieldData[indexField].require == 1) {
        $('#required' + id).prop('checked', true);
      } else {
        $('#required' + id).prop('checked', false);
      }
      $('#btnUpdate' + id).click(() => {
        that.updateRadio(id, indexField);
      });
      $('#cancelUpdate' + id).click(() => {
        $('#' + 'fieldContent' + id).empty();
        that.addRadioData(id, this.listFieldData[indexField]);
        $('#fieldBoder' + id).addClass('field');
      });
    }
  }

  addRadioOption(id, indexField, first?) {
    if (this.listFieldData[indexField]) {
      if (Object.keys(this.listFieldData[indexField].value).length > 0) {
        let listData = Object.keys(this.listFieldData[indexField].value).map(
          (x) => this.listFieldData[indexField].value[x]
        );
        for (let i = 0; i < listData.length; i++) {
          this.numberObj['radio' + id]++;
          this.numberObj['listRadioKey' + id].push(i);
          let idOption = this.ramdomIdField(this.numberObj['radio' + id]);
          while (this.numberObj['listRadio' + id].indexOf(idOption) > -1) {
            idOption = this.ramdomIdField(this.numberObj['radio' + id]);
          }
          $('#divAddOptionRadio' + id).remove();
          let html =
            `
                <div id="itemRadio${idOption}" class="col-6">
                    <div id="itemRadioOption${idOption}" class="radio-custom radio-primary">
                        <input type="radio" checked="">
                        <label for="inputChecked" style="width: 100%">
                            <div class="form-group form-material">
                                <input id="radioValue${idOption}"
                                       type="text"
                                       class="form-control"
                                       value="${listData[i].value}"
                                       placeholder="${that.translate.instant('NHAP_DU_LIEU')}"
                                       style="margin-top: -13px; padding-right: 25px">
                                <small id="radioValueValidate${idOption}" style="color: red"></small>
                            </div>
                        </label>
          `;
          if (listData[i].isVisible) {
            html +=
              `<i id="show` +
              idOption +
              `" class="wb wb-eye float-right" style="position: absolute; cursor: pointer; right: 5px; top: 0px;  color: #061178;"></i>`;
          } else {
            html +=
              `<i id="hide` +
              idOption +
              `" class="wb wb-eye-close float-right" style="position: absolute; cursor: pointer; right: 5px; top: 0px"></i>`;
          }
          html +=
            `
              </div>
            </div>
            <div id="divAddOptionRadio${id}" class="col-6">
                      <div id="addOptionRadio${id}" class="form-horizontal add-new p-10 pl-10 mb-15">
                          <i class="icon wb-plus" style="margin: auto; font-size: 10px;"></i>
                      </div>
             </div>
          `;
          $('#optionRadio' + id).append(html);
          $('#radioValue' + idOption).click(() => {
            $('#radioValueValidate' + idOption).text('');
          });
          $('#radioValue' + idOption).focusout(() => {
            if ($('#radioValue' + idOption).val()) {
              $('#radioValueValidate' + idOption).text('');
            } else {
              $('#radioValueValidate' + idOption).text(that.translate.instant('KHONG_DUOC_DE_TRONG'));
            }
          });
          this.numberObj['listRadio' + id].push(idOption);
          $('#addOptionRadio' + id).click(function () {
            that.addRadioOption(id);
          });
          $('#' + 'closeOptionRadio' + idOption).click(function (res) {
            var index = parseInt(
              res.currentTarget.id.toString().split('closeOptionRadio')[1]
            );
            for (let i = 0; i < that.numberObj["listRadio" + id].length; i++) {
              if (that.numberObj['listRadio' + id][i] == index) {
                $('#' + 'itemRadio' + index).remove();
                that.numberObj['listRadio' + id].splice(i, 1);
                that.numberObj['listRadioKey' + id].splice(i, 1);
                that.numberObj['radio' + id]--;
              }
            }
          });
          if (listData[i].isVisible) {
            this.showRadioOption(id, idOption);
            $('#checkBoxValue' + idOption).attr('isVisible', 1);
          } else {
            this.hideRadioOption(id, idOption);
            $('#checkBoxValue' + idOption).attr('isVisible', 2);
          }
        }
      }
    } else {
      if (first) {
        this.numberObj['radio' + id]++;
        this.numberObj['listRadioKey' + id].push(null);
        let idOption = this.ramdomIdField(this.numberObj['radio' + id]);
        while (this.numberObj['listRadio' + id].indexOf(idOption) > -1) {
          idOption = this.ramdomIdField(this.numberObj['radio' + id]);
        }
        $('#divAddOptionRadio' + id).remove();
        $('#optionRadio' + id).append(
          `
            <div id="itemRadio${idOption}" class="col-6">
                    <div class="radio-custom radio-primary">
                        <input type="radio" checked="">
                        <label for="inputChecked" style="width: 100%">
                            <div class="form-group form-material">
                                <input id="radioValue${idOption}"
                                       type="text"
                                       class="form-control"
                                       placeholder="${that.translate.instant('NHAP_DU_LIEU')}"
                                       style="margin-top: -13px; padding-right: 25px">
                                <small id="radioValueValidate${idOption}" style="color: red"></small>
                            </div>
                        </label>

                    </div>
            </div>
            <div id="divAddOptionRadio${id}" class="col-6">
                      <div id="addOptionRadio${id}" class="form-horizontal add-new p-10 pl-10 mb-15">
                          <i class="icon wb-plus" style="margin: auto; font-size: 10px;"></i>
                      </div>
             </div>
        `
        );
        $('#radioValue' + idOption).click(() => {
          $('#radioValueValidate' + idOption).text('');
        });
        $('#radioValue' + idOption).focusout(() => {
          if ($('#radioValue' + idOption).val()) {
            $('#radioValueValidate' + idOption).text('');
          } else {
            $('#radioValueValidate' + idOption).text(that.translate.instant('KHONG_DUOC_DE_TRONG'));
          }
        });
        this.numberObj['listRadio' + id].push(idOption);
        $('#addOptionRadio' + id).click(function () {
          that.addRadioOption(id);
        });
        $('#' + 'closeOptionRadio' + idOption).click(function (res) {
          var index = parseInt(
            res.currentTarget.id.toString().split('closeOptionRadio')[1]
          );
          for (let i = 0; i < that.numberObj["listRadio" + id].length; i++) {
            if (that.numberObj['listRadio' + id][i] == index) {
              $('#' + 'itemRadio' + index).remove();
              that.numberObj['listRadio' + id].splice(i, 1);
              that.numberObj['listRadioKey' + id].splice(i, 1);
              that.numberObj['radio' + id]--;
            }
          }
        });
      } else {
        this.numberObj['radio' + id]++;
        this.numberObj['listRadioKey' + id].push(null);
        let idOption = this.ramdomIdField(this.numberObj['radio' + id]);
        while (this.numberObj['listRadio' + id].indexOf(idOption) > -1) {
          idOption = this.ramdomIdField(this.numberObj['radio' + id]);
        }
        $('#divAddOptionRadio' + id).remove();
        $('#optionRadio' + id).append(
          `
            <div id="itemRadio${idOption}" class="col-6">
                    <div class="radio-custom radio-primary">
                        <input type="radio" checked="">
                        <label for="inputChecked" style="width: 100%">
                            <div class="form-group form-material">
                                <input id="radioValue${idOption}"
                                       type="text"
                                       class="form-control"
                                       placeholder="${that.translate.instant('NHAP_DU_LIEU')}"
                                       style="margin-top: -13px; padding-right: 25px">
                                <small id="radioValueValidate${idOption}" style="color: red"></small>
                            </div>
                        </label>
                        <i id="closeOptionRadio${idOption}" class="wb wb-close float-right showButton" style="position: absolute; cursor: pointer; right: 5px; top: 0px"></i>
                    </div>
            </div>
            <div id="divAddOptionRadio${id}" class="col-6">
                      <div id="addOptionRadio${id}" class="form-horizontal add-new p-10 pl-10 mb-15">
                          <i class="icon wb-plus" style="margin: auto; font-size: 10px;"></i>
                      </div>
             </div>
        `
        );
        $('#radioValue' + idOption).click(() => {
          $('#radioValueValidate' + idOption).text('');
        });
        $('#radioValue' + idOption).focusout(() => {
          if ($('#radioValue' + idOption).val()) {
            $('#radioValueValidate' + idOption).text('');
          } else {
            $('#radioValueValidate' + idOption).text(that.translate.instant('KHONG_DUOC_DE_TRONG'));
          }
        });
        this.numberObj['listRadio' + id].push(idOption);
        $('#addOptionRadio' + id).click(function () {
          that.addRadioOption(id);
        });
        $('#' + 'closeOptionRadio' + idOption).click(function (res) {
          var index = parseInt(
            res.currentTarget.id.toString().split('closeOptionRadio')[1]
          );
          for (let i = 0; i < that.numberObj["listRadio" + id].length; i++) {
            if (that.numberObj['listRadio' + id][i] == index) {
              $('#' + 'itemRadio' + index).remove();
              that.numberObj['listRadio' + id].splice(i, 1);
              that.numberObj['listRadioKey' + id].splice(i, 1);
              that.numberObj['radio' + id]--;
            }
          }
        });
      }
    }
  }

  showRadioOption(id, idOption) {
    $('#show' + idOption).click(function () {
      $('#show' + idOption).remove();
      $('#itemRadioOption' + idOption).append(
        `<i id="hide` +
        idOption +
        `" class="wb wb-eye-close float-right" style="position: absolute; cursor: pointer; right: 5px; top: 0px;"></i>`
      );
      $('#radioValue' + idOption).attr('isVisible', 2);
      that.hideRadioOption(id, idOption);
    });
  }

  hideRadioOption(id, idOption) {
    $('#hide' + idOption).click(function () {
      $('#hide' + idOption).remove();
      $('#itemRadioOption' + idOption).append(
        `<i id="show` +
        idOption +
        `" class="wb wb-eye float-right" style="position: absolute; cursor: pointer; right: 5px; top: 0px;  color: #061178;"></i>`
      );
      $('#radioValue' + idOption).attr('isVisible', 1);
      that.showRadioOption(id, idOption);
    });
  }

  updateRadio(id, indexField) {
    let item: any = {};
    item.id = this.listFieldData[indexField].id;
    item.type = 3;
    item.name = $('#fieldName' + id).val();
    item.require = $('#required' + id).prop('checked') ? 1 : 0;
    item.status = $('#showField' + id).prop('checked') ? 1 : 0;
    item.value = '';
    let listRadio = this.numberObj['listRadio' + id];
    if (listRadio.length > 0) {
      let option: any = [];
      let h = 0;
      for (let cr = 0; cr < listRadio.length; cr++) {
        if (!$('#radioValue' + listRadio[cr]).val()) {
          $('#radioValueValidate' + listRadio[cr]).text(that.translate.instant('KHONG_DUOC_DE_TRONG'));
          h++;
        }
        let _item: any = {
          value: $('#radioValue' + listRadio[cr]).val(),
        };
        if ($('#radioValue' + listRadio[cr]).attr('isvisible') == 1) {
          _item.isVisible = 1;
        } else if ($('#radioValue' + listRadio[cr]).attr('isvisible') == 2) {
          _item.isVisible = 0;
        } else {
          _item.isVisible = 1;
        }
        if (
          this.numberObj['listRadioKey' + id][cr] ||
          this.numberObj['listRadioKey' + id][cr] == 0
        ) {
          _item.key = that.numberObj['listRadioKey' + id][cr];
        }
        option.push(_item);
      }
      item.value = option;
      if (!item.name) {
        $('#validateName' + id).text(that.translate.instant('TEN_TRUONG_KHONG_DUOC_DE_TRONG'));
      }
      if (item.name && h == 0) {
        this.stampService.updateFieldGuarantee(item).subscribe((res) => {
          if (!res.error) {
            $('#' + 'fieldContent' + id).empty();
            this.listFieldData[indexField] = item;
            this.addRadioData(id, item);
            $('#fieldBoder' + id).addClass('field');
          }
        });
      }
    }
  }

  addRadioData(id, data) {
    let listData = Object.keys(data.value).map((x) => data.value[x]);
    let html = ``;
    html +=
      `
      <div class="row" style="position: relative">
        <div class="col-12">
           <div class="form-group">
              <label>` +
      data.name +
      `
    `;
    if (data.require == 1) {
      html += `<span style="color: red"> (*)</span>`;
    }
    html += `</label>
        <div class="list-unstyled list-inline">
    `;
    for (let i = 0; i < listData.length; i++) {
      if (listData[i].isVisible == 1) {
        html +=
          `<li class="list-inline-item">
                    <div class="radio-custom radio-primary">
                      <input type="radio" name="inputCheckboxes" checked="">
                      <label>` +
          listData[i].value +
          `</label>
                    </div>
                  </li>
                  `;
      }
    }
    if (data.status) {
      html += `
      </div>
    </div>
    <span style="position: absolute;top: -5px;right: 20px;font-size: 12px;" class="badge badge-info">" + that.translate.instant('HIEN_THI') + "</span>
</div>`;
    } else {
      html += `
      </div>
    </div>
    <span style="position: absolute;top: -5px;right: 20px;font-size: 12px;" class="badge badge-default">" + that.translate.instant('AN') + "</span>
</div>`;
    }

    $('#fieldContent' + id).append(html);
  }

  formatKey(str) {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
    str = str.replace(/Đ/g, 'D');
    // Some system encode vietnamese combining accent as individual utf-8 characters
    // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
    str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
    // Remove extra spaces
    // Bỏ các khoảng trắng liền nhau
    str = str.replace(/ + /g, ' ');
    str = str.trim();
    // Remove punctuations
    // Bỏ dấu câu, kí tự đặc biệt
    str = str.replace(
      /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
      ' '
    );
    return str;
  }

  updateSetting() {
    let listValue: any = [];
    let h = 0;
    for (let i = 0; i < this.listField.length; i++) {
      if (!this.listFieldData[i]) {
        let idField = this.listField[i];
        let item: any = {};
        switch (this.listType[i]) {
          case 0: {
            item.type = 0;
            item.name = $('#fieldName' + idField).val();
            item.require = $('#required' + idField).prop('checked') ? 1 : 0;
            item.status = $('#showField' + idField).prop('checked') ? 1 : 0;
            item.value = null;
            break;
          }
          case 1: {
            item.type = 1;
            item.name = $('#fieldName' + idField).val();
            item.require = $('#required' + idField).prop('checked') ? 1 : 0;
            item.status = $('#showField' + idField).prop('checked') ? 1 : 0;
            item.value = null;
            break;
          }
          case 2: {
            item.type = 2;
            item.name = $('#fieldName' + idField).val();
            item.require = $('#required' + idField).prop('checked') ? 1 : 0;
            item.status = $('#showField' + idField).prop('checked') ? 1 : 0;
            item.value = [];
            let listSelectBox = this.numberObj['listSelectBox' + idField];
            if (listSelectBox.length > 0) {
              let option: any = '';
              for (let sl = 0; sl < listSelectBox.length; sl++) {
                if (!$('#selectValue' + listSelectBox[sl]).val()) {
                  $('#selectValueValidate' + listSelectBox[sl]).text(
                    that.translate.instant('KHONG_DUOC_DE_TRONG')
                  );
                  h++;
                }
                if (sl > 0) {
                  option += ',' + $('#selectValue' + listSelectBox[sl]).val();
                } else {
                  option += $('#selectValue' + listSelectBox[sl]).val();
                }
                item.value.push($('#selectValue' + listSelectBox[sl]).val())
              }

            }
            break;
          }
          case 3: {
            item.type = 3;
            item.name = $('#fieldName' + idField).val();
            item.require = $('#required' + idField).prop('checked') ? 1 : 0;
            item.status = $('#showField' + idField).prop('checked') ? 1 : 0;
            item.value = [];
            let listRadio = this.numberObj['listRadio' + idField];
            if (listRadio.length > 0) {
              let option: any = '';
              for (let cr = 0; cr < listRadio.length; cr++) {
                if (!$('#radioValue' + listRadio[cr]).val()) {
                  $('#radioValueValidate' + listRadio[cr]).text(
                    that.translate.instant('KHONG_DUOC_DE_TRONG')
                  );
                  h++;
                }
                if (cr > 0) {
                  option += ',' + $('#radioValue' + listRadio[cr]).val();
                } else {
                  option += $('#radioValue' + listRadio[cr]).val();
                }
                item.value.push($('#radioValue' + listRadio[cr]).val())
              }
            }
            break;
          }
          case 4: {
            console.log('vao day ko')
            item.type = 4;
            item.name = $('#fieldName' + idField).val();
            item.require = $('#required' + idField).prop('checked') ? 1 : 0;
            item.status = 1;
            item.value = [];
            let listCheckBox = this.numberObj['listCheckBox' + idField];
            if (listCheckBox.length > 0) {
              let option: any = '';
              for (let ck = 0; ck < listCheckBox.length; ck++) {
                if (!$('#checkBoxValue' + listCheckBox[ck]).val()) {
                  $('#checkBoxValueValidate' + listCheckBox[ck]).text(
                    that.translate.instant('KHONG_DUOC_DE_TRONG')
                  );
                  h++;
                }
                if (ck > 0) {
                  option += ',' + $('#checkBoxValue' + listCheckBox[ck]).val();
                } else {
                  option += $('#checkBoxValue' + listCheckBox[ck]).val();
                }
                item.value.push($('#checkBoxValue' + listCheckBox[ck]).val())
              }

            }
            break;
          }
          case 5: {
            item.type = 5;
            item.name = $('#fieldName' + idField).val();
            item.require = $('#required' + idField).prop('checked') ? 1 : 0;
            item.status = $('#showField' + idField).prop('checked') ? 1 : 0;
            item.value = null;
            break;
          }
        }
        if (!item.name) {
          h++;
          $('#validateName' + idField).text(that.translate.instant('TEN_TRUONG_KHONG_DUOC_DE_TRONG'));
        }
        listValue.push(item);
      }
    }
    if (listValue.length > 0 && h == 0) {
      let opt: any = {
        fields: listValue,
      };
      this.stampService.createFieldGuarantee(opt).subscribe((res) => {
        if (!res.error && res.data) {
          $('#fields').empty();
          this.getFieldGuarantee();
        }
      });
    }
  }

  back() {
    this.router.navigate(['/evs/guarantee/add']);
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/guarantee/guarantee-setting/guarantee-setting.component.ts